import React from 'react';
import { usePlayerContext } from '../Player/PlayerContext';
import { Box, ClickableBox, ClickableFlex, Flex } from '../ui';
import BeatRow from './BeatRow';
import { useDropsContext } from '../Drops/DropsContext';
import { PlaylistChoices, Sort } from '../common';
import PlaylistLoader from './PlaylistLoader';
import { ArrowDown, ArrowUp } from 'components/ui/Arrows';
import { useWalletItemsContext } from 'components/WalletItemsContext';
import { futuraContractAddress } from 'utils/config';

const PlaylistTab: React.FC<any> = ({
  text,
  playlist,
  selectPlaylist,
  selectedPlaylist,
  disabled,
  ...rest
}) => {
  const isActive = playlist === selectedPlaylist;

  return (
    <ClickableBox
      color="copy"
      paddingBottom="2"
      borderBottom={isActive ? '2px solid' : ''}
      borderColor="highlight"
      onClick={disabled ? () => {} : () => selectPlaylist(playlist)}
      disabled={!!disabled}
      {...rest}
    >
      {text}
    </ClickableBox>
  );
};

const ListControls: React.FC<any> = () => {
  const { toggleSort, priceSort, selectedPlaylist, setSelectedPlaylist } = usePlayerContext();
  const { ownedItems } = useWalletItemsContext();
  const { dropConfig } = useDropsContext();
  const ownedForDrop = ownedItems.filter(item => item.contract_address === dropConfig.contractAddress);
  const isFutura = dropConfig.contractAddress === futuraContractAddress; 

  return (
    <Flex px="24px" alignCenter>
      <Flex minWidth="150px">
        <PlaylistTab
          mr="3"
          text="All Beats"
          playlist={PlaylistChoices.default}
          selectedPlaylist={selectedPlaylist}
          selectPlaylist={setSelectedPlaylist}
        />
        <PlaylistTab
          text="My Beats"
          playlist={PlaylistChoices.owned}
          selectedPlaylist={selectedPlaylist}
          selectPlaylist={setSelectedPlaylist}
          disabled={!ownedForDrop || ownedForDrop.length === 0}
        />
      </Flex>
      {!isFutura && (
        <Flex width="100%" justifyContent="flex-end">
          <ClickableFlex color="copy" pb={2} pt={0} onClick={toggleSort} fontSize="1" alignCenter>
            Sort by Price
            {priceSort === Sort.asc && <ArrowUp color="primary" size={5} />}
            {priceSort === Sort.desc && <ArrowDown color="primary" size={5} />}
          </ClickableFlex>
        </Flex>
      )}
    </Flex>
  );
};

const Playlist: React.FC<any> = ({ ...styles }) => {
  const { playlist, status } = usePlayerContext();

  return (
    <Box
      width="100%"
      bg="secondary"
      margin="0 auto"
      pb="4"
      maxWidth={['100%', '100%', '100%', '600px']}
      overflow="hidden"
      {...styles}
    >
      <ListControls />
      <Box overflow="scroll" height="100%">
        {status === 'loading' ? (
          <PlaylistLoader />
        ) : (
          <>
            {playlist.map(o => (
              <BeatRow key={o.id} original={o} />
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Playlist;
